import React from 'react';

const Classroom = () => {
  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    }}>
      {/* Hero Section */}
      <div style={{
        textAlign: 'center',
        marginBottom: '40px',
        padding: '50px 20px',
        background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
        color: 'white',
        borderRadius: '15px'
      }}>
        <h1 style={{
          fontSize: '42px',
          fontWeight: 'bold',
          marginBottom: '20px',
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
        }}>
          🎓 Classroom Name Spinner - Perfect Teaching Tool
        </h1>
        <p style={{
          fontSize: '20px',
          marginBottom: '30px',
          opacity: '0.95',
          maxWidth: '800px',
          margin: '0 auto 30px'
        }}>
          Transform your classroom engagement with our <strong>student name randomizer</strong>. Fair, fun, and effective for promoting participation in any educational setting.
        </p>
        <a 
          href="/"
          style={{
            display: 'inline-block',
            backgroundColor: 'white',
            color: '#dc2626',
            padding: '15px 35px',
            borderRadius: '30px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '18px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
          }}
        >
          Start Using Free Classroom Spinner 🚀
        </a>
      </div>

      {/* Benefits for Teachers */}
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '32px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#333',
          marginBottom: '30px'
        }}>
          🎯 Why Teachers Choose Our Random Student Selector
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '30px'
        }}>
          <div style={{
            padding: '25px',
            border: '2px solid #f0f0f0',
            borderRadius: '10px',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '15px'
            }}>⚖️</div>
            <h3 style={{
              fontSize: '22px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '12px'
            }}>
              Promotes Fairness
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Our <strong>classroom spinner tool</strong> ensures every student has an equal opportunity to participate, eliminating any perception of teacher bias.
            </p>
          </div>

          <div style={{
            padding: '25px',
            border: '2px solid #f0f0f0',
            borderRadius: '10px',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '15px'
            }}>🎮</div>
            <h3 style={{
              fontSize: '22px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '12px'
            }}>
              Increases Engagement
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Turn routine participation into an exciting game. Students stay alert knowing they could be selected by our <strong>random name picker</strong>.
            </p>
          </div>

          <div style={{
            padding: '25px',
            border: '2px solid #f0f0f0',
            borderRadius: '10px',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '15px'
            }}>⏱️</div>
            <h3 style={{
              fontSize: '22px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '12px'
            }}>
              Saves Time
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              No more mental calculations or trying to remember who answered last. Our <strong>student name randomizer</strong> makes selection instant.
            </p>
          </div>
        </div>
      </div>

      {/* Classroom Scenarios */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '40px',
        borderRadius: '12px',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '32px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#333',
          marginBottom: '30px'
        }}>
          📋 Perfect Classroom Scenarios
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '25px'
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '25px',
            borderRadius: '10px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '15px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              💬 Question & Answer Sessions
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Use our <strong>pick a student randomly</strong> feature to ensure fair participation during Q&A sessions.
            </p>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
                Keeps all students engaged and ready
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
                Prevents the same students from always volunteering
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
                Encourages shy students to participate
              </li>
            </ul>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '25px',
            borderRadius: '10px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '15px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              👥 Group Formation
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Create balanced teams using our <strong>wheel spinner for classroom</strong> activities and projects.
            </p>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
                Eliminates friendship-based grouping
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
                Creates diverse learning opportunities
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
                Saves time on group assignment decisions
              </li>
            </ul>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '25px',
            borderRadius: '10px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '15px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              📚 Reading & Presentations
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Determine reading order or presentation sequence with our <strong>attendance name picker</strong>.
            </p>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
                Reduces presentation anxiety with randomness
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
                Ensures everyone gets equal speaking time
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
                Makes the process transparent and fair
              </li>
            </ul>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '25px',
            borderRadius: '10px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '15px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              🎲 Brain Breaks & Games
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Add fun to learning with educational games using our <strong>random student selector</strong>.
            </p>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
                Choose game leaders or first players
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
                Select students for special roles
              </li>
              <li style={{ marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>✓</span>
                Make break-time activities more engaging
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* How to Use */}
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '32px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#333',
          marginBottom: '30px'
        }}>
          🚀 How to Use Our Classroom Name Picker
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '25px',
          marginBottom: '30px'
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '80px',
              height: '80px',
              backgroundColor: '#dc2626',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
              fontSize: '36px',
              color: 'white',
              fontWeight: 'bold'
            }}>
              1
            </div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              marginBottom: '12px',
              color: '#333'
            }}>
              Add Student Names
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Enter your students' names one by one into our <strong>name picker for teachers</strong>
            </p>
          </div>

          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '80px',
              height: '80px',
              backgroundColor: '#dc2626',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
              fontSize: '36px',
              color: 'white',
              fontWeight: 'bold'
            }}>
              2
            </div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              marginBottom: '12px',
              color: '#333'
            }}>
              Spin the Wheel
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Click the spin button and watch the excitement build as the wheel rotates
            </p>
          </div>

          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '80px',
              height: '80px',
              backgroundColor: '#dc2626',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
              fontSize: '36px',
              color: 'white',
              fontWeight: 'bold'
            }}>
              3
            </div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              marginBottom: '12px',
              color: '#333'
            }}>
              Get Fair Results
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              See the randomly selected student with celebratory confetti animation
            </p>
          </div>
        </div>

        <div style={{
          backgroundColor: '#f0f8ff',
          padding: '25px',
          borderRadius: '10px',
          border: '2px solid #e0e7ff'
        }}>
          <h3 style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#dc2626',
            marginBottom: '15px',
            textAlign: 'center'
          }}>
            💡 Pro Teacher Tips
          </h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '20px'
          }}>
            <div>
              <h4 style={{ fontWeight: 'bold', marginBottom: '8px' }}>Save Time Setup:</h4>
              <p style={{ fontSize: '14px', color: '#666' }}>
                Keep a list of your student names ready to quickly copy-paste into our <strong>classroom spinner tool</strong>
              </p>
            </div>
            <div>
              <h4 style={{ fontWeight: 'bold', marginBottom: '8px' }}>Build Suspense:</h4>
              <p style={{ fontSize: '14px', color: '#666' }}>
                Let the wheel spin for the full duration to maximize engagement and excitement
              </p>
            </div>
            <div>
              <h4 style={{ fontWeight: 'bold', marginBottom: '8px' }}>Multiple Rounds:</h4>
              <p style={{ fontSize: '14px', color: '#666' }}>
                Remove selected students for subsequent rounds to ensure everyone gets a turn
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div style={{
        textAlign: 'center',
        padding: '50px 30px',
        backgroundColor: '#dc2626',
        color: 'white',
        borderRadius: '15px'
      }}>
        <h2 style={{
          fontSize: '36px',
          fontWeight: 'bold',
          marginBottom: '20px'
        }}>
          Ready to Transform Your Classroom? 🎉
        </h2>
        <p style={{
          fontSize: '20px',
          marginBottom: '30px',
          opacity: '0.95',
          maxWidth: '600px',
          margin: '0 auto 30px'
        }}>
          Join thousands of educators using our <strong>free classroom spinner</strong> to create fair, engaging, and fun learning environments.
        </p>
        <a 
          href="/"
          style={{
            display: 'inline-block',
            backgroundColor: 'white',
            color: '#dc2626',
            padding: '15px 40px',
            borderRadius: '30px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '20px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
          }}
        >
          Start Your Free Classroom Spinner Now →
        </a>
        <div style={{
          marginTop: '20px',
          fontSize: '16px',
          opacity: '0.8'
        }}>
          No registration required • Works on all devices • 100% Free
        </div>
      </div>
    </div>
  );
};

export default Classroom;